<template>
  <Card>
    <template #title="">
      <div class="p-d-flex p-justify-between">
        ระบุข้อความ PDPA (Personal Data Protection Act)
        <div>
          <Button
            icon="pi pi-save"
            label="บันทึก"
            @click="() => onSaveDocument(false)"
          ></Button>
          <Button
            icon="pi pi-send"
            class="p-ml-2 p-button-danger"
            label="เริ่มใช้งาน"
            @click="() => onSaveDocument(true)"
          ></Button>
          <BackButton class="p-ml-2"></BackButton>
        </div>
      </div>
    </template>
    <template #content="">
      <div class="p-grid">
        <div class="p-col-12 ">
          <div>
            กรุณาระบุข้อความ PDPA (Personal Data Protection Act)
            สำหรับใช้แสดงในหน้าจอที่ในขณะที่ผู้ใช้งานกำลัง Login เข้าระบบ
          </div>
          <div>
            หลังจากบันทึกและมีการ update ข้อมูลแล้ว
            ระบบจะบังคับให้ผู้ใช้งานทำการยอมรับข้อตกลงก่อนการเข้าใช้งานใหม่ทุกครั้ง
          </div>
        </div>
        <div class="p-col-12 p-field">
          <Editor v-model="pdpa" editorStyle="height: 300px"></Editor>
        </div>
        <div class="p-col-12 p-lg-4 p-md-6 p-fluid">
          <span class="p-float-label">
            <InputText
              id="lastUpdateOn"
              v-model="lastUpdateOnText"
              readonly
            ></InputText>
            <label for="lastUpdateOn">วันที่แก้ไขล่าสุด</label>
          </span>
        </div>
      </div>
    </template>
  </Card>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, computed } from "vue";
import { usePlugin } from "@/plugins";
import { GetPdpaMessageResponse, UpsertPdpaMessageRequest } from "@/types";
import { last, set } from "ramda";

export default defineComponent({
  name: "ConfigPdpaScreen",
  setup() {
    const pdpa = ref("");
    const lastUpdateOn = ref<Date | null>();
    const {
      axios,
      error,
      success,
      setLoading,
      dayjs,
      formatAppDateTime,
    } = usePlugin();

    const loadDocument = async () => {
      setLoading(true);
      try {
        const result = await axios.get<GetPdpaMessageResponse>(
          "api/v1/services/pdpa"
        );
        success("ดึงข้อมูลสำเร็จแล้ว");

        pdpa.value = result.data.message ?? "";
        lastUpdateOn.value = result.data.updateOn ?? null;
      } catch (e) {
        error(e);
      } finally {
        setLoading(false);
      }
    };

    const onSaveDocument = async (release: boolean) => {
      setLoading(true);
      try {
        await axios.post("api/v1/services/pdpa/upsert", {
          message: pdpa.value,
          updateOn: lastUpdateOn.value,
          release: release,
        } as UpsertPdpaMessageRequest);
        success("บันทึกข้อมูลสำเร็จแล้ว");

        loadDocument();
      } catch (e) {
        error(e);
      } finally {
        setLoading(false);
      }
    };
    const lastUpdateOnText = computed(() => {
      if (!lastUpdateOn.value) {
        return "N/A";
      } else {
        return formatAppDateTime(lastUpdateOn.value);
      }
    });
    onMounted(() => loadDocument());

    return { pdpa, lastUpdateOnText, onSaveDocument };
  },
});
</script>

<style></style>
